<template>
    <Userlanding>
        <div class="teachDiv">
            <div class="content">
                <h1 class="title">What is our Teach-n-Trade Pilot?</h1>
                <h4>Be a part of our pilot and help design the teach-n-trade program. Participants must be a student 18+ or
                    an older adult to fit into one of the categories.</h4>
                    <br/>
                <h6>Timeline</h6>
                <ul>
                    <li> Sign up here</li>
                    <li>We match you with an older adult based on your answers before the round closes (dates on our main
                        page)</li>
                    <li>Spend 3 weeks teaching and trading!</li>
                    <li>Provide your feedback in a form or interview</li>
                </ul>
                <br/>
                <h6>What do the 3 weeks look like? </h6>
                <ul>
                    <li>Week 1: Meet and get to know your buddy using our booklet for support</li>
                    <li>Week 2: You or your buddy teach</li>
                    <li>Week 3: The opposite buddy teaches</li>
                </ul>
                <div class="timeline">
                    <div class="item">
                        Sign up!
                    </div>
                    <div class="item">
                        Get matched.
                    </div>
                    <div class="item">
                        Teach-n-trade
                    </div>
                    <div class="item">
                        New experience/skills,
                        volunteer hours + more!
                    </div>
                </div>
            </div>
            <div class="chart">
                <div class="stepC">What our past participants have said:</div>
                <div class="stepD">“[My buddy] was very committed
                    to the project and very personable.
                    I looked forward to our meetings and
                    enjoyed sharing info back and forth.”</div>
                <div class="stepC">
                    “It was a delight to spend time with
                    someone who was interested in many of
                    the same things I am interested in,
                    who was open, honest and well-meaning.”
                </div>
                <div class="stepD">“It was really good! [My buddy] was
                    very friendly and personable.
                    I was expecting I'd have to be the main
                    lead and organize all of the technology
                    and take charge of all the conversations,
                    but instead it was very 50-50
                    and a nice balance.”</div>
            </div>
        </div>
    </Userlanding>
</template>
<script>
import Userlanding from '../components/userlanding.vue';
export default {
    components: {
        Userlanding
    }
}
</script>

<style lang="less" scoped>
.teachDiv {
    min-height: 60vh;
    margin: 10rem 5rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 4rem;

    .content {
        .timeline {
            display: flex;
            flex-direction: row;
            gap: 2rem;
            margin-top: 5rem;
            flex-wrap: wrap;

            .item {
                background: rgba(238, 195, 79, 0.16);
                border-radius: 10px;
                height: 10rem;
                width:25rem;
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 2rem 2rem;
            }
        }
    }

    .chart {
        display: flex;
        flex-direction: column;
        gap: 3rem;

        .stepC {
            background: rgba(238, 195, 79, 0.16);
            border-radius: 10px;
            width: 45rem;
            padding: 2rem 5rem;
        }

        .stepD {
            background: rgba(238, 195, 79, 0.63);
            border-radius: 10px;
            width: 45rem;
            padding: 2rem 5rem;
        }
    }
}
</style>